import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { DataOfficerField } from './DataOfficerField';

export const DataOfficerFieldExtension = FormFieldBlueprint.make({
  name: 'data-officer-field',
  params: {
    field: async () =>
      createFormField({
        name: 'DataOfficerField',
        component: DataOfficerField,
      }),
  },
});
